import * as tslib_1 from "tslib";
import { environment } from '../../environments/environment';
import { LOGIN_TOKEN_KEY } from '../constants/auth.constants';
export function runPreAuth() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var isReload, navEntries, token, isCallback, url, code, resp, data, cleanUrl, e_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!environment.useCiam) {
                        return [2 /*return*/, true];
                    }
                    isReload = false;
                    navEntries = performance.getEntriesByType('navigation');
                    if (navEntries && navEntries.length > 0) {
                        isReload = navEntries[0].type === 'reload';
                    }
                    else if (performance.navigation) { // legacy fallback
                        isReload = performance.navigation.type === 1;
                    }
                    try {
                        sessionStorage.setItem('IS_PAGE_RELOAD', isReload ? 'true' : 'false');
                        if (isReload) {
                            sessionStorage.clear(); // drop any stale tokens/data on hard reload
                        }
                    }
                    catch (_b) { }
                    token = sessionStorage.getItem(LOGIN_TOKEN_KEY);
                    isCallback = window.location.pathname.includes('/auth/cim');
                    if (!token && !isCallback) {
                        if (environment.ciamUrl) {
                            window.location.replace(environment.ciamUrl);
                            return [2 /*return*/, false];
                        }
                        return [2 /*return*/, true];
                    }
                    if (!(!token && isCallback)) return [3 /*break*/, 8];
                    url = new URL(window.location.href);
                    code = url.searchParams.get('code');
                    if (!code) {
                        return [2 /*return*/, true];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, , 7]);
                    console.time('[PreAuth] code_exchange');
                    return [4 /*yield*/, fetch(environment.apiHost + "/makpak/auth/code", {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({ authCode: code })
                        })];
                case 2:
                    resp = _a.sent();
                    console.timeEnd('[PreAuth] code_exchange');
                    if (!resp.ok) return [3 /*break*/, 4];
                    return [4 /*yield*/, resp.json()];
                case 3:
                    data = _a.sent();
                    if (data && data.token) {
                        sessionStorage.setItem(LOGIN_TOKEN_KEY, data.token);
                        sessionStorage.setItem('CIAM_PREAUTH_DONE', 'true');
                        try {
                            cleanUrl = window.location.origin + window.location.pathname;
                            window.history.replaceState({}, document.title, cleanUrl);
                        }
                        catch (_c) { }
                    }
                    return [3 /*break*/, 5];
                case 4:
                    console.warn('[PreAuth] Code exchange failed status', resp.status);
                    _a.label = 5;
                case 5: return [3 /*break*/, 7];
                case 6:
                    e_1 = _a.sent();
                    console.warn('[PreAuth] Code exchange error', e_1);
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/, true];
                case 8:
                    sessionStorage.setItem('CIAM_PREAUTH_DONE', 'true');
                    return [2 /*return*/, true];
            }
        });
    });
}
